export const CourseTopicData = `
  id
  name
  description
  isActive
`;
